type AuthCallbacks = {
  onTokensUpdated: (
    accessToken: string,
    refreshToken?: string
  ) => void;
  onLogout: () => void;
};

let callbacks: AuthCallbacks | null = null;



const authTokenService = {
    registerCallbacks: (value: AuthCallbacks) => {
        callbacks = value;
    },
    getAccessToken : () : string | null => sessionStorage.getItem("SUMMERYOU_TOKEN"),
    getRefreshToken : () : string | null => sessionStorage.getItem("SUMMERYOU_RETOKEN"),
    setTokens : (
        accessToken : string,
        refreshToken? : string
    ) => {
        sessionStorage.setItem("SUMMERYOU_TOKEN", accessToken);

        if (refreshToken !== undefined)
            sessionStorage.setItem("SUMMERYOU_RETOKEN", refreshToken);

        callbacks?.onTokensUpdated(accessToken, refreshToken);
    },


    logOut : () => {
        sessionStorage.removeItem("SUMMERYOU_TOKEN");
        sessionStorage.removeItem("SUMMERYOU_RETOKEN");
        sessionStorage.removeItem("SUMMERYOU_USERNAME");

        callbacks?.onLogout();
    }
};

export default authTokenService;